module.exports = __webpack_public_path__ + "static/media/logo-dark.2fed7a40.png";